/** The API's default ladder division is displayed as "League" throughout the site. */
export function divisionLabel(name: string | null): string | null {
  if (name === null) return null;

  return name.trim().toLowerCase() === "competition" ? "League" : name;
}
